export const MAX_TOTAL_SIZE_MB = 25;

export const validateFiles = (files: File | File[] | null): boolean => {
  if (!files) return true;
  const fileArray = Array.isArray(files) ? files : [files];
  if (fileArray.length === 0) return true;
  const totalSize = fileArray.reduce((total, file) => total + file.size, 0);
  const MAX_TOTAL_SIZE_BYTES = MAX_TOTAL_SIZE_MB * 1024 * 1024;
  return totalSize <= MAX_TOTAL_SIZE_BYTES;
};